import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: 'How do I get the material?',
    a: "You'll receive a download link via email immediately after purchase. One click and the entire bundle is on your device. 100% digital PDF, no apps or extra platforms required."
  }, {
    q: 'Can I use it on my phone during lessons?',
    a: 'Absolutely. Every volume is formatted to be read clearly on any device — phone, tablet, laptop, or printed out. Take it to the gym, the field, or the classroom.'
  }, {
    q: 'Is it suitable for all school levels?',
    a: 'Yes. P.E. READY covers the full progression from beginner (9th category) to advanced (1st category), making it ideal for primary, middle, and high school PE teachers.'
  }, {
    q: 'Are the 5 bonuses included in every offer?',
    a: 'Yes. Every purchase today includes all 5 bonuses at no extra cost. This is a limited-time launch offer.'
  }, {
    q: 'Can I adapt the sessions for different class sizes?',
    a: 'Every session plan is designed to be scalable. Whether you have 10 students or 40, the structures adapt without extra planning on your part.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-brand-ink mb-16" data-id="element-67">
          ❓ FREQUENTLY ASKED{' '}
          <span className="text-brand-accent" data-id="element-68">QUESTIONS</span>
        </h2>
        <div className="space-y-4" data-id="element-69">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden shadow-sm" data-id="element-70">
              <button className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent hover:bg-brand-card-hover transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-71">
                <span className="font-bold text-brand-ink text-lg pr-8" data-id="element-72">
                  <span className="text-brand-gold mr-2" data-id="element-73">{i + 1} —</span>{' '}
                  {faq.q}
                </span>
                <span className={`text-brand-gold text-2xl flex-shrink-0 transition-transform duration-300 leading-none ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-74">
                  ▾
                </span>
              </button>
              {openIndex === i && <div role="region" data-id="element-75">
                  <div className="px-8 pb-8 text-brand-muted border-t border-brand-border pt-6 text-lg leading-relaxed" data-id="element-76">
                    {faq.a}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}